














































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getSuffix } from '../../utils/toolsForCommon'
import axios from 'axios'
import Store from '../../store'
@Component({
  name: 'capitalShiftToAffirmTable'
})
export default class CapitalShiftToAffirmTable extends Vue {
  @Prop({ default: '' }) public villagesAndTowns: string
  @Prop({ default: '' }) public orgName: string
  @Prop({ default: () => {} }) public tableDetail: any
  @Prop({ default: 'insert' }) public appearType: string
  @Prop({ default: '资金转入确认表' }) public title: string
  @Prop({ default: '转入' }) public subtitle: string
  // 确认表相关：
  public predictMoneyOfShiftTo: string = ''
  public moneyOfShiftTo: string = ''
  public timeOfShiftTo: string = ''
  // 附件：
  public transferFile: string = ''
  public bankBalanceFile: string = ''
  // loading：
  public loadingForModuleTable: boolean = false

  get iconForStatus (): string {
    const { status } = this.tableDetail
    let iconForStatus = ''
    if (status === '已确认') {
      iconForStatus = 'icon-yiwancheng'
    }
    if (status === '已驳回') {
      iconForStatus = 'icon-bohui'
    }
    return iconForStatus
  }

  get colorForStatus (): string {
    const { status } = this.tableDetail
    let colorForStatus = ''
    if (status === '已确认') {
      colorForStatus = 'status_success'
    }
    if (status === '已驳回') {
      colorForStatus = 'status_turn_down'
    }
    return colorForStatus
  }

  // 针对需要编辑的，默认赋值：
  @Watch('tableDetail', { immediate: true, deep: true })
  tableDetailChange (newval): void {
    if (Object.keys(newval).length) {
      this.predictMoneyOfShiftTo = newval.estimateAmount || ''
      this.moneyOfShiftTo = newval.transferAmount || ''
      this.timeOfShiftTo = newval.time || ''
      this.transferFile = newval.transferFile || ''
      this.bankBalanceFile = newval.bankBalanceFile || ''
    }
  }

  beforeUpload () {

  }

  mySelfUploadForTransferFile (param) {
    this.mySelfUpload(param, 'transferFile')
  }

  mySelfUploadForBankBalanceFile (param) {
    this.mySelfUpload(param, 'bankBalanceFile')
  }

  async mySelfUpload (param, who) {
    const _that = this
    const params = {
      contentType: param.file.type,
      suffix: getSuffix(param.file.name)
    }
    this.loadingForModuleTable = true
    const { data: result } = await (this as any).$http.uploadFile(params)
    if (result.code !== 200) return this.$message.error(result.msg)
    let reader = new FileReader()
    reader.readAsArrayBuffer(param.file)
    reader.onload = async function () {
      const onloadResult = reader.result
      await axios.put(result.data, onloadResult, {
        headers: {
          'Content-Type': param.file.type,
          authorization: Store.state.User.token
        }
      })
      _that.$message.success('上传成功')
      const url = result.data.split('?')[0]
      const obj = {
        url,
        name: param.file.name
      }
      _that[who] = JSON.stringify(obj)
      _that.loadingForModuleTable = false
    }
  }

  previewBtn (v) {
    if (!v) return this.$message.error('抱歉，没有可预览的文件哦！')
    this.$emit('previewBtn', v)
  }
}
